import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'
import dayjs from 'dayjs'

const UserPermissionDetails = () => {
  const { userPermissions, isLoading } = useSelector((state) => state.userPermissions)

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: 'Type Of Login',
      dataIndex: 'typeOfLogIn',
      key: 'typeOfLogIn',
    },
    {
      title: 'Permission Level',
      dataIndex: 'permissionLevel',
      key: 'permissionLevel',
    },
    {
      title: 'Type Of Role',
      dataIndex: 'typeOfRole',
      key: 'typeOfRole',
    },
    {
      title: 'Server Name',
      dataIndex: 'serverName',
      key: 'serverName',
    },
    {
      title: 'Database Name',
      dataIndex: 'dbName',
      key: 'dbName',
    },
    {
      title: 'Captured Date',
      dataIndex: 'capturedDate',
      key: 'capturedDate',
      render: (date) => (date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : 'N/A'),
    },
  ]

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!userPermissions || userPermissions.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  return (
    <CommonTable
      columns={columns}
      dataSource={userPermissions}
      rowKey="userPermissionId"
    />
  )
}

export default UserPermissionDetails
